import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import es from './es.json';
import ca from './ca.json';

export type Locale = 'es' | 'ca';

const translations: Record<Locale, Record<string, unknown>> = { es, ca };

interface I18nState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

export const useI18nStore = create<I18nState>()(
  persist(
    (set) => ({
      locale: 'es',
      setLocale: (locale) => set({ locale }),
    }),
    {
      name: 'kakuat-i18n',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

function getNestedValue(obj: unknown, path: string): string | undefined {
  const keys = path.split('.');
  let current: unknown = obj;
  for (const key of keys) {
    if (current == null || typeof current !== 'object') return undefined;
    current = (current as Record<string, unknown>)[key];
  }
  return typeof current === 'string' ? current : undefined;
}

export function useTranslation() {
  const { locale, setLocale } = useI18nStore();

  const t = (key: string, params?: Record<string, string | number>): string => {
    let value = getNestedValue(translations[locale], key);
    if (value === undefined) {
      value = getNestedValue(translations.es, key);
    }
    if (value === undefined) return key;

    if (params) {
      return value.replace(/\{(\w+)\}/g, (_, name) =>
        params[name] !== undefined ? String(params[name]) : `{${name}}`
      );
    }
    return value;
  };

  return { t, locale, setLocale };
}
